var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.24853V12.2485H16.5M21 12.2485C21 13.4304 20.7672 14.6008 20.3149 15.6927C19.8626 16.7846 19.1997 17.7768 18.364 18.6125C17.5282 19.4482 16.5361 20.1112 15.4442 20.5635C14.3522 21.0157 13.1819 21.2485 12 21.2485C10.8181 21.2485 9.64778 21.0157 8.55585 20.5635C7.46392 20.1112 6.47177 19.4482 5.63604 18.6125C4.80031 17.7768 4.13738 16.7846 3.68508 15.6927C3.23279 14.6008 3 13.4304 3 12.2485C3 9.86159 3.94821 7.5724 5.63604 5.88457C7.32387 4.19675 9.61305 3.24854 12 3.24854C14.3869 3.24854 16.6761 4.19675 18.364 5.88457C20.0518 7.5724 21 9.86159 21 12.2485Z",
    stroke: "#BEBEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.ec19858d398da5d89d7165fb6d9329e6.svg";
export { ForwardRef as ReactComponent };